import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlaidIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: .5,
		y: .5,
		width: 47,
		height: 47,
		rx: 7.5,
		fill: "white",
		stroke: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M32.5914 31.1068L29.4432 27.9588L31.9176 25.4846L33.6006 27.1676L32.5914 31.1068ZM31.9176 22.5154L29.4432 20.0412L32.5914 16.8932L33.6006 20.8326L31.9176 22.5154ZM27.1678 14.3994L31.1069 15.4085L27.9588 18.5567L25.4846 16.0825L27.1678 14.3994ZM22.5156 16.0826L20.0413 18.5567L16.8933 15.4086L20.8325 14.3994L22.5156 16.0826ZM15.4085 16.8929L18.5568 20.0413L16.0826 22.5154L14.3993 20.8321L15.4085 16.8929ZM16.0826 25.4844L18.5568 27.9586L15.4085 31.1068L14.3993 27.1677L16.0826 25.4844ZM20.8324 33.6006L16.893 32.5914L20.0413 29.4432L22.5155 31.9174L20.8324 33.6006ZM26.4742 27.9587L24 30.4329L21.5258 27.9587L24 25.4844L26.4742 27.9587ZM27.9588 21.5257L30.433 24L27.9588 26.4742L25.4845 24L27.9588 21.5257ZM22.5155 24L20.0413 26.4742L17.5672 24L20.0413 21.5258L22.5155 24ZM21.5259 20.0413L24.0001 17.5671L26.4742 20.0412L24 22.5154L21.5259 20.0413ZM25.4845 31.9174L27.9588 29.4433L31.1068 32.5914L27.1676 33.6004L25.4845 31.9174ZM34.0824 34.0823L36 26.5979L33.4021 24L35.9998 21.402L34.0823 13.9174L26.5978 12L24.0001 14.598L21.4019 12.0001L13.9174 13.9177L12 21.4021L14.5981 24L12 26.598L13.9174 34.0825L21.4021 36L24 33.4019L26.5979 35.9999L34.0824 34.0823Z",
		fill: "#111212"
	})]
});
export default SvgPlaidIcon;
